import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

import { Product } from '@app-domains/content-blocks/components/product-card/product-card.types'

@Component({
    selector: 'app-related-products-hits',
    templateUrl: './related-products-hits.component.html',
    styleUrls: ['./related-products-hits.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class RelatedProductsHitsComponent {

    @Input()
    public products: Product[] = []

}
